<template>
  <div class='component-page'>
    <div class="filter-area">
      <Row style='text-align: center;' class='add_search'>
        <Col span="2" style='float:left'>
        <i-button icon="md-add" shape="circle" type="primary" style='margin-right:10px' @click="add_new">添加</i-button>
        </Col>
        <Col span="5" style='float:right;'>
        <Input search v-model="formItem.name" placeholder="角色" @on-search="handleSearch" style="width: 230px;" />
        </Col>
      </Row>
    </div>
    <div class="edittable-table-height-con">
      <Row class='search-select'>
        <Col span="4">
        <Select filterable v-model="formItem.status" placeholder="状态" @on-change="handleSearch" clearable style="width:180px">
                          <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                      </Select>
        </Col>
        <!--
                  <Col span="2" style="float:right" class='search-btn'>
                  <i-button shape="circle" type="primary" @click="handleSearch">查询</i-button>
                  </Col>
                  -->
  
      </Row>
      <Table border stripe :columns="editIncellColumns" :data="editIncellData"></Table>
      <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
        <Page style='float: right' size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
      </div>
    </div>
  
    <Modal v-model="addEdit" width="400" :title="modalTitle">
      <Form ref="formdate" :model="formdate" :rules="ruleValidate" label-position="top">
        <Row>
          <Col span="24">
          <FormItem label="角色名称" prop='name'>
            <Input v-model="formdate.name" type="text" placeholder="请输入..."></Input>
          </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
          <FormItem label="角色说明" prop='description'>
            <Input v-model="formdate.description" type="text" placeholder="请输入..."></Input>
          </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type='primary' shape="circle" ghost @click='cancel'>取消</Button>
        <Button type="primary" shape="circle" @click="add_save('formdate')">保存</Button>
      </div>
    </Modal>
    <Modal v-model="perModal" width="750" title="修改权限">
      <CheckboxGroup v-model="checkAllGroup">
        <div v-for='item in checkList' style='margin-bottom: 20px;'>
          <p style='font-size:13px; font-weight: 900;margin-bottom: 10px;'>{{item.title}}</p>
          <Checkbox v-for='list in item.children' :label="list.id" :key="list.id" style='width:160px;margin-bottom: 10px;'>
            <span>{{list.title}}</span>
          </Checkbox>
        </div>
      </CheckboxGroup>
      <div slot="footer">
        <Button type='primary' ghost shape="circle" @click='cancelPer'>取消</Button>
        <Button type="primary" shape="circle" @click="addPer">确定</Button>
      </div>
    </Modal>
    <Modal v-model="remindModal" width="440" @on-cancel='cancelRemind' class='remind'>
      <div class='remindContent'>
        {{remindContent}}
      </div>
      <div slot="footer">
        <Button type='primary' ghost shape="circle" @click='cancelRemind'>取消</Button>
        <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
      </div>
    </Modal>
  </div>
</template>



<script>
  import {
    fetchTableList,
    setUpdate,
    setAdd,
    fetchedit,
    changeStatus,
    fetchPermissionList,
    changePermissionList
  } from '@/api/roleList'
  export default {
    name: 'user-components',
  
    data() {
      return {
        total_count: 0, // 列表总条数
        editIncellData: [], // 列表数据
        addEdit: false, // 添加/修改的Modal的显隐
        perModal: false, // 权限弹层
        remindModal: false,
        modalTitle: '新增',
        remindContent: '',
        role_id: '', // 角色ID
        user_id: '',
        checkAllGroup: [],
        checkList: [],
        formItem: {
          page: 1, // 列表当前页数
          page_size: 10,
          name: '',
          status: ''
        }, // 搜索条件
        statusList: [{
            id: '1',
            name: '禁止'
          },
          {
            id: '0',
            name: '正常'
          }
        ],
        ruleValidate: {
          name: [{
            required: true,
            message: '角色名称不能为空',
            trigger: 'blur'
          }],
          description: [{
            required: true,
            message: '角色说明不能为空',
            trigger: 'blur'
          }]
        }, // 添加/修改参数验证
        formdate: {
          id: '',
          name: '',
          description: '',
          range: []
        }, // 添加/修改的参数
        form: {
          role_id: ''
        },
        editIncellColumns: [{
            title: '序号',
            align: 'center',
            type: 'index',
            width: 100
          },
          {
            title: '角色名称',
            align: 'center',
            key: 'name'
          },
          {
            title: '角色说明',
            align: 'center',
            key: 'description'
          },
          {
            title: '操作',
            align: 'center',
            key: 'action',
            width: 220,
            align: 'center',
            render: (h, params) => {
              if (params.row.status == 0) {
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      ghost: true
  
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.changePermission(params.row.id)
                      }
                    }
                  }, '修改权限'),
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      ghost: true
  
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.edit(params.row.id)
                      }
                    }
                  }, '修改'),
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small',
                      ghost: true
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.changeState(params.row.id, '是否禁用此角色', '禁用成功')
                      }
                    }
                  }, '禁用')
                ])
              } else {
                return h('div', [
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      ghost: true
  
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.changePermission(params.row.id)
                      }
                    }
                  }, '修改权限'),
                  h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      ghost: true
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.edit(params.row.id)
                      }
                    }
                  }, '修改'),
                  h('Button', {
                    props: {
                      type: 'info',
                      size: 'small',
                      ghost: true
                    },
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.changeState(params.row.id, '是否启用此用户', '启用成功')
                      }
                    }
                  }, '启用')
                ])
              }
            }
          }
        ] // 列表标题
      }
    },
    methods: {
      // 获取列表数据
      getData() {
        this.$Loading.start()
        fetchTableList(this.formItem)
          .then(responese => {
            responese = responese.data
            this.$Loading.finish()
            if (responese.code == 200) {
              this.editIncellData = responese.data.list
              this.total_count = parseInt(responese.data.total_count)
            } else if (responese.code == 14001) {
              this.$Message.error(responese.msg);
              this.$store.dispatch('handleLogOut').then(res => {
                this.$store.commit('clearOpenedSubmenu')
                this.$router.push({
                  name: 'login'
                })
              })
            } else {
              this.$Message.error(responese.msg)
            }
          })
      },
      // 添加
      add_new() {
        this.modalTitle = '新增'
        this.formdate.id = ''
        this.formdate.name = ''
        this.formdate.description = ''
        this.addEdit = true
      },
      // 添加和修改
      add_save(name) {
        this.$refs[name].validate(valid => {
          if (valid) {
            if (this.formdate.id != '') {
              setUpdate({
                id: this.formdate.id,
                name: this.formdate.name,
                description: this.formdate.description
              }).then(responese => {
                responese = responese.data
                if (responese.code == 200) {
                  this.addEdit = false
                  this.getData()
                } else if (responese.code == 14001) {
                  this.$Message.error(responese.msg);
                  this.$store.dispatch('handleLogOut').then(res => {
                    this.$store.commit('clearOpenedSubmenu')
                    this.$router.push({
                      name: 'login'
                    })
                  })
                } else {
                  this.$Message.error(responese.msg)
                }
              })
            } else {
              setAdd({
                name: this.formdate.name,
                description: this.formdate.description
              }).then(responese => {
                responese = responese.data
                if (responese.code == 200) {
                  this.addEdit = false
                  this.getData()
                } else if (responese.code == 14001) {
                  this.$Message.error(responese.msg);
                  this.$store.dispatch('handleLogOut').then(res => {
                    this.$store.commit('clearOpenedSubmenu')
                    this.$router.push({
                      name: 'login'
                    })
                  })
                } else {
                  this.$Message.error(responese.msg)
                }
              })
            }
          }
        })
      },
      // 修改角色详情
      edit(id) {
        this.formdate.id = id
        fetchedit({
          id: id
        }).then(res => {
          this.$Loading.finish()
          res = res.data
          if (res.code == 200) {
            var data = res.data
            this.formdate.name = data.name
            this.formdate.description = data.description
            this.modalTitle = '修改'
            this.addEdit = true
          } else if (res.code == 14001) {
            this.$Message.error(responese.msg);
            this.$store.dispatch('handleLogOut').then(res => {
              this.$store.commit('clearOpenedSubmenu')
              this.$router.push({
                name: 'login'
              })
            })
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      primaryRemind() {
        changeStatus({
            id: this.user_id
          })
          .then(res => {
            var responese = res.data
            if (responese.code == 200) {
              this.$Message.success('设置成功')
              this.remindModal = false
              this.getData()
            } else if (responese.code == 14001) {
              this.$Message.error(responese.msg);
              this.$store.dispatch('handleLogOut').then(res => {
                this.$store.commit('clearOpenedSubmenu')
                this.$router.push({
                  name: 'login'
                })
              })
  
            } else {
              this.$Message.error(responese.msg)
            }
          })
      },
      cancelRemind() {
        this.remindModal = false
      },
      // 封禁/解封用户
      changeState(id, info1, info2) {
        this.user_id = id
        this.remindContent = info1
        this.remindModal = true
      },
  
      // 获取修改权限列表，显示弹层
      changePermission(id) {
        this.role_id = id
        this.checkAllGroup = []
        fetchPermissionList({
          id: id
        }).then(res => {
          res = res.data
          if (res.code == 200) {
            var data = res.data
            for (var i = 0; i < data.length; i++) {
              if (data[i].is_checked == 1) {
                data[i].selected = true
                data[i].expand = true
                // this.checkAllGroup.push(data[i].id)
              }
              if (data[i].children) {
                for (var j = 0; j < data[i].children.length; j++) {
                  if (data[i].children[j].is_checked == 1) {
                    data[i].children[j].checked = true
                    data[i].expand = true
                    this.checkAllGroup.push(data[i].children[j].id)
                  }
                }
              }
            }
            this.checkList = data
            this.perModal = true
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      // 关闭修改权限弹层
      cancelPer() {
        this.perModal = false
      },
      cancel() {
        this.addEdit = false
      },
      // 修改权限
      addPer() {
        changePermissionList({
          id: this.role_id,
          powers: this.checkAllGroup
        }).then(res => {
          res = res.data
          if (res.code == 200) {
            this.$Message.success('修改成功')
            this.perModal = false
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      handleSearch() {
        this.formItem.page = 1
        this.getData()
      },
      // 改变当前页码
      changePage(row) {
        this.formItem.page = row
        this.getData()
      }
    },
    created() {
      this.getData()
    }
  }
</script>
